export interface Itinerary {
  duration: number;
  distance: number;
}
